(function () {
  function normaliseQuantity(container) {
    const input = container.querySelector('.quantity__input');
    if (!input) return;

    function getPackAndMin() {
      let pack = Number(input.dataset.pack || input.getAttribute('step') || 1);
      if (!Number.isFinite(pack) || pack < 1) pack = 1;

      let min = Number(input.dataset.min || input.getAttribute('min') || pack);
      if (!Number.isFinite(min) || min < 1) min = pack;

      return { pack, min };
    }

    function clampToPack() {
      const { pack, min } = getPackAndMin();

      let value = parseInt(input.value, 10);
      if (!Number.isFinite(value) || value < min) value = min;

      // Snap to nearest *higher* multiple of pack
      if (value % pack !== 0) {
        value = Math.ceil(value / pack) * pack;
      }

      input.value = value;
      input.min = String(min);
      input.step = String(pack);
    }

    // Initial normalisation
    clampToPack();

    // +/- buttons: wait until Dawn has changed the value, then clamp
    container.querySelectorAll('.quantity__button').forEach((btn) => {
      btn.addEventListener('click', () => {
        setTimeout(clampToPack, 0);
      });
    });

    // IMPORTANT: run BEFORE Dawn's change handlers (capture phase),
    // so the packed value is what gets sent to /cart/change.
    input.addEventListener(
      'change',
      function () {
        clampToPack();
      },
      true // capture = true
    );

    // Safety: if user tabs out after typing, normalise
    input.addEventListener('blur', clampToPack);
  }

  function initAll(root) {
    (root || document)
      .querySelectorAll('quantity-input')
      .forEach(normaliseQuantity);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  // For dynamic section reloads
  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
